webpackJsonp([67250462289515],{

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Collections = __webpack_require__(25);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Collections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'retrieve'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This page describes how to retrieve a collection of resources using a Collection.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Basic Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s say you have an API endpoint located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:1337/tweets'
	      ),
	      ' that returns a collection of tweets that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      [\n        {\n          id: 1,\n          text: \'An old tweet\'\n        },\n        {\n          id: 2,\n          text: \'A new tweet\'\n        }\n      ]\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To retrieve those Tweets, we need to issue a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'GET'
	      ),
	      ' request to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:1337/tweets'
	      ),
	      ' that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      GET http://localhost:1337/tweets\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The code below demonstrates how to do that using a Collection:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Collection } from \'lore-models\';\n\n      const TweetCollection = Collection.extend({\n        url: \'http://localhost:1337/tweets\'\n      });\n\n      const tweets = new TweetCollection();\n\n      tweets.fetch();\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'First we import ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Collection'
	      ),
	      ' from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-models'
	      ),
	      '. Then we create a new Collection called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'TweetCollection'
	      ),
	      ', and provide the location of the API endpoint we want to interact with as the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'url'
	      ),
	      ' property.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once we have the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'TweetCollection'
	      ),
	      ' created, we create an instance of that collection, and then we call ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.fetch()'
	      ),
	      ' to retrieve that collection of tweets through the API.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.fetch()'
	      ),
	      ' call will result in a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'GET'
	      ),
	      ' request, and an AJAX request will be sent that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      GET http://localhost:1337/tweets\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the AJAX request returns, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets'
	      ),
	      ' instance will be automatically updated, and you\'ll be able to view the resources via the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'toJSON()'
	      ),
	      ' method of the instance, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      tweets.toJSON() = [\n        {\n          id: 1,\n          text: \'An old tweet\'\n        },\n        {\n          id: 2,\n          text: \'A new tweet\'\n        }\n      ]\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.fetch()'
	      ),
	      ' method returns a promise. If you need access to the response object once the API call returns, you can do that using this code:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      tweets.fetch().then(function(response) {\n        // do something with response\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The response object will have a structure that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      const response = {\n        config: {\n          headers: {\n            Accept: "application/json, text/plain, */*"\n          },\n          method: "GET",\n          responseType: "json",\n          url: "http://localhost:1337/tweets"\n        },\n        data: [\n          {\n            id: 1,\n            text: \'An old tweet\'\n          },\n          {\n            id: 2,\n            text: \'A new tweet\'\n          }\n        ],\n        headers: {\n          "content-type": "application/json"\n        },\n        request: {...}, // XMLHttpRequest\n        status: 200,\n        statusText: "OK"\n      };\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Advanced Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Collections use the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/axios/axios' },
	        'axios'
	      ),
	      ' library for handling for all network request, and that means the properties you set on collections are ultimately just converted into a config object that ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'axios'
	      ),
	      ' understands.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'fetch()'
	      ),
	      ' method, that means the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.fetch()'
	      ),
	      ' call we demonstrated above is ultimately converted into this ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'axios'
	      ),
	      ' call:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import axios from \'axios\';\n\n      axios({\n        url: \'http://localhost:1337/tweets\',\n        method: \'get\',\n        headers: {\n          \'Content-Type\': \'application/json\'\n        }\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you need more control over your network requests, such as adding headers, or providing query parameters, simply provide an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'options'
	      ),
	      ' object to get ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.fetch()'
	      ),
	      ' call like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      tweets.fetch({\n        headers: {\n          \'Content-Type\': \'application/json\'\n          Authorization: \'Bearer token\'\n        },\n        data: {\n          page: 1\n        }\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This object will be passed directly to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'axios'
	      ),
	      ' call.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn about all of the config options that ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'axios'
	        ),
	        'supports ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/axios/axios#request-config' },
	          'here'
	        ),
	        '.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collections-usage-retrieve-js-d766db9e39e6624ef3b0.js